import React from "react"
import "./index.css"

const CheckBox = ({ onClick, checked }) => {
  return (
    <div className="cbx-ct">
      <input
        className="inp-cbx"
        id="cbx"
        type="checkbox"
        checked={checked}
        style={{ display: "none" }}
      />
      <label className="cbx" for="cbx" onClick={onClick}>
        <span>
          <svg width="12px" height="10px" viewbox="0 0 12 10">
            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
          </svg>
        </span>
        <span className="text">
          Я даю згоду на обробку та використання моїх персональних даних
        </span>
      </label>
    </div>
  )
}

export default CheckBox
